<!-- hidden field should prevent Hubspot form submissions https://knowledge.hubspot.com/forms/use-non-hubspot-forms#requirements-to-capture-non-hubspot-form-submissions -->

<label class="hidden" aria-hidden={true} for="amex">AMEX</label>
<input id="amex" name="amex" type="hidden" />
